import "@/App.css";
import Terminal from "@/mt5/Terminal";

function App() {
  return <Terminal />;
}

export default App;
